import React, { useState } from "react";
import styles from "./Home.module.css";
import { ReactComponent as WordIcon } from '../word.svg';
import { ReactComponent as Napis } from '../napis.svg';
import { ReactComponent as ExcelIcon } from '../excel.svg';
import { ReactComponent as GmailIcon } from '../gmail.svg';
import { ReactComponent as SheetsIcon } from '../sheets.svg';
import { ReactComponent as PdfIcon } from '../pdf.svg';
import { ReactComponent as DriveIcon } from '../drive.svg';
import { ReactComponent as OpenAiIcon } from '../openai.svg';
import { ReactComponent as AwsIcon } from '../aws.svg';
import { ReactComponent as SchoolIcon } from '../school.svg';
import { ReactComponent as AgreementIcon } from '../agreement.svg';
import { ReactComponent as AutomationIcon } from '../automation.svg';
import { Link } from "react-router-dom";
import { HashLink } from 'react-router-hash-link';
import { CheckCircle, Zap, FileText, Bot, Wand2, FileCog, Award } from 'lucide-react';


// Załaduj font Inter z Google Fonts (w index.html lub przez <link> w public/index.html)

export default function Home() {
  const [menuOpen, setMenuOpen] = useState(false);
  const screenshotUrl = process.env.PUBLIC_URL + '/mainphoto.png';
  const screenshotUrlMobile = process.env.PUBLIC_URL + '/mainphoto3.jpg';

  // Zamknij menu po kliknięciu linku lub overlay
  const handleMenuClose = () => setMenuOpen(false);

  // Kolory kafelków imitujące różne narzędzia (oryginał: Bubble, Make, Notion, Airtable, Zapier, Pipedrive, n8n, .b)
  const iconTiles = [
    { className: 'icon1', bg: '#fff' },
    { className: 'icon2', bg: '#f3f0ff' },
    { className: 'icon3', bg: '#e0f7fa' },
    { className: 'icon4', bg: '#fff3e0' },
    { className: 'icon5', bg: '#e8f5e9' },
    { className: 'icon6', bg: '#fce4ec' },
    { className: 'icon7', bg: '#e3f2fd' },
    { className: 'icon8', bg: '#fff' },
  ];

  // Placeholdery na różne ikony – podmień na prawdziwe SVG
  const icons = [
    { className: styles.icon1, icon: <WordIcon /> },
    { className: styles.icon2, icon: <WordIcon /> },
    { className: styles.icon3, icon: <WordIcon /> },
    { className: styles.icon4, icon: <WordIcon /> },
    { className: styles.icon5, icon: <WordIcon /> },
    { className: styles.icon6, icon: <WordIcon /> },
    { className: styles.icon7, icon: <WordIcon /> },
    { className: styles.icon8, icon: <WordIcon /> },
  ];

  return (
    <div className={styles.root}>
      {/* HEADER */}
      <header className={styles.header}>
        <Link to="/">
          <img src="/logo2.png" className={styles.logo} />
        </Link>
        <nav className={styles.navBar}>
          <div className={styles.navLinks}>
            {/* <a href="#about" className={styles.navLink}>O nas</a>
            <a href="#services" className={styles.navLink}>Usługi</a>
            <a href="#case-study" className={styles.navLink}>Case Study</a>
            <a href="#webinars" className={styles.navLink}>Webinary</a>
            <a href="#knowledge" className={styles.navLink}>Baza wiedzy</a> */}
          </div>
          <div className={styles.navButtons}>
            <HashLink smooth to="/kontakt#formularz" className={styles.navBtnPrimary}>Bezpłatna konsultacja</HashLink>
            <a href="/login" className={styles.navBtnSecondary}>Zaloguj</a>
          </div>
        </nav>
        {/* Hamburger icon for mobile */}
        <button
          className={styles.hamburger}
          aria-label="Otwórz menu"
          onClick={() => setMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
      </header>

      <main className={styles.mainContent}>
        {/* HERO SECTION */}
        <section className={styles.hero} id="top">
          <div className={styles.heroContent}>
            <Napis className={styles.heroNapis} />
            <h1 className={styles.heroTitle}>
            Papierowa rewolucja<br />dla Twojego nowoczesnego biura
            </h1>
            <p className={styles.heroDesc}>
              Nie trać czasu i pieniędzy na ręczne wypełnianie dokumentów.<br /> Zautomatyzuj je, oszczędź czas i skaluj swój biznes.
            </p>
            <div className={styles.heroBtns}>
              <HashLink smooth to="/kontakt#formularz" className={styles.heroBtnPrimary}>Umów bezpłatną konsultację</HashLink>
              <HashLink smooth to="/#services" className={styles.heroBtnSecondary}>Sprawdź nasze usługi</HashLink>
            </div>
            <div className={styles.heroIcons}>
              <div className={styles.icon1}><div className={styles.iconTile}><OpenAiIcon /></div></div>
              <div className={styles.icon2}><div className={styles.iconTile}><WordIcon /></div></div>
              <div className={styles.icon3}><div className={styles.iconTile}><GmailIcon /></div></div>
              <div className={styles.icon4}><div className={styles.iconTile}><SheetsIcon /></div></div>
              <div className={styles.icon5}><div className={styles.iconTile}><PdfIcon /></div></div>
              <div className={styles.icon6}><div className={styles.iconTile}><DriveIcon /></div></div>
              <div className={styles.icon7}><div className={styles.iconTile}><AwsIcon /></div></div>
              <div className={styles.icon8}><div className={styles.iconTile}><ExcelIcon /></div></div>
            </div>
          </div>
        </section>

        {/* SERVICES SECTION */}
        <section className={styles.services} id="services">
          <div className={styles.servicesTitle}>Czym jest Paperly?</div>
          <div className={styles.servicesHeader}>Twoje zautomatyzowane biuro.</div>
          <div className={styles.servicesDesc}>
            Paperly to platforma SaaS, która automatyzuje generowanie dokumentów w Twojej firmie. Zamiast tracić godziny na ręczne wypełnianie umów, faktur czy raportów, możesz wygenerować setki gotowych dokumentów w kilka sekund. Wystarczy szablon Word i dane z formularza lub pliku Excel. Twoje dane są bezpieczne – Paperly spełnia wszystkie wymogi RODO i nie wymaga wdrożenia IT.
          </div>
          <div className={styles.servicesGrid}>
            {/* Karta 1: Automatyzacja dokumentów */}
            <div className={styles.serviceCard}>
              <div className={styles.serviceCardIconWrapper}>
                <Zap size={32} strokeWidth={2.5} />
              </div>
              <div className={styles.serviceCardTitle}>Błyskawiczne Generowanie</div>
              <div className={styles.serviceCardDesc}>
                Prześlij szablon, podłącz dane i generuj setki dokumentów jednocześnie. Prosto, szybko i bezbłędnie.
              </div>
            </div>
            {/* Karta 2: Inteligentne szablony */}
            <div className={styles.serviceCard}>
              <div className={styles.serviceCardIconWrapper}>
                <FileText size={32} strokeWidth={2.5} />
              </div>
              <div className={styles.serviceCardTitle}>Inteligentne Szablony</div>
              <div className={styles.serviceCardDesc}>
                Używaj warunków logicznych, aby tworzyć dynamiczne dokumenty, które same dostosowują treść.
              </div>
            </div>
            {/* Karta 3: Integracje */}
            <div className={styles.serviceCard}>
              <div className={styles.serviceCardIconWrapper}>
                <Bot size={32} strokeWidth={2.5} />
              </div>
              <div className={styles.serviceCardTitle}>Pełna Elastyczność</div>
              <div className={styles.serviceCardDesc}>
                Wypełniaj dane za pomocą prostych formularzy online lub importuj je masowo z plików Excel.
              </div>
            </div>
          </div>
        </section>

        {/* BENEFITS SECTION */}
        <section className={styles.benefits}>
          <div className={styles.benefitsContent}>
            <div className={styles.benefitsText}>
              <h2 className={styles.benefitsTitle}>Stworzone dla Twojej Wygody</h2>
              <p className={styles.benefitsDesc}>
                Paperly zostało zaprojektowane, aby maksymalnie uprościć i przyspieszyć Twoją pracę. Zapomnij o skomplikowanych wdrożeniach i nieintuicyjnych interfejsach.
              </p>
              <ul className={styles.benefitsList}>
                <li>
                  <CheckCircle size={22} className={styles.benefitIcon} />
                  <div>
                    <strong>Automatyzacja bez kompromisów:</strong> Twórz zaawansowane reguły i warunki bez znajomości kodu. Oszczędzaj nawet 10 godzin tygodniowo.
                  </div>
                </li>
                <li>
                  <CheckCircle size={22} className={styles.benefitIcon} />
                  <div>
                    <strong>Pełna kontrola nad danymi:</strong> Importuj dane z Excela lub wypełniaj je w prostych formularzach. Twoje dane są zawsze bezpieczne i zgodne z RODO.
                  </div>
                </li>
                <li>
                  <CheckCircle size={22} className={styles.benefitIcon} />
                  <div>
                    <strong>Bezpieczeństwo i niezawodność:</strong> Z Paperly wygenerowano już ponad 10 000 dokumentów dla firm z całej Polski.
                  </div>
                </li>
              </ul>
              <HashLink smooth to="/kontakt#formularz" className={styles.heroBtnPrimary}>Zacznij automatyzację</HashLink>
            </div>
            <div className={styles.benefitsImage}>
              <div className={styles.monitor} aria-hidden="true">
                <div className={styles.monitorBezel}>
                  <div className={styles.monitorScreen}>
                    <div className={styles.screenTopBar}>
                      <span className={styles.dot}/>
                      <span className={styles.dot}/>
                      <span className={styles.dot}/>
                    </div>
                    <div className={styles.screenshotBg} style={{ backgroundImage: `url(${screenshotUrl})` }} />
                  </div>
                </div>
                <div className={styles.monitorStand} />
                <div className={styles.monitorFoot} />
              </div>
            </div>
          </div>
        </section>

        {/* MOBILE MONITOR (only on mobile) */}
        <div className={styles.mobileMonitor}>
          <div className={styles.monitor} aria-hidden="true">
            <div className={styles.monitorBezel}>
              <div className={styles.monitorScreen}>
                <div className={styles.screenTopBar}>
                  <span className={styles.dot}/>
                  <span className={styles.dot}/>
                  <span className={styles.dot}/>
                </div>
                <img
                  className={styles.screenshotImg}
                  src={screenshotUrlMobile}
                  srcSet={`${screenshotUrlMobile} 1x, ${screenshotUrl} 2x`}
                  alt="Podgląd aplikacji Paperly"
                  loading="lazy"
                />
              </div>
            </div>
            <div className={styles.monitorStand} />
            <div className={styles.monitorFoot} />
          </div>
        </div>

        {/* HOW IT WORKS SECTION */}
        <section className={styles.howItWorks}>
          <div className={styles.servicesTitle}>Jak to działa?</div>
          <div className={styles.servicesHeader}>3 proste kroki do automatyzacji</div>
          <div className={styles.howItWorksGrid}>
            <div className={styles.howItWorksCard}>
              <div className={styles.howItWorksIcon}>1</div>
              <div className={styles.howItWorksTitle}>Wgraj Szablon</div>
              <div className={styles.howItWorksDesc}>
                Przygotuj szablony dokumentów w formacie .docx zgodnie z instrukcją i zaimportuj do programu.
              </div>
            </div>
            <div className={styles.howItWorksCard}>
              <div className={styles.howItWorksIcon}>2</div>
              <div className={styles.howItWorksTitle}>Podłącz Dane</div>
              <div className={styles.howItWorksDesc}>
                Wypełnij formularz online lub wgraj plik Excel z danymi do uzupełnienia na podstawie automatyzacji w programie.
              </div>
            </div>
            <div className={styles.howItWorksCard}>
              <div className={styles.howItWorksIcon}>3</div>
              <div className={styles.howItWorksTitle}>Generuj Dokumenty</div>
              <div className={styles.howItWorksDesc}>
                Kliknij "Generuj" i pobierz gotowe pliki w kilka sekund. Wszystko szybko i wygodnie.
              </div>
            </div>
          </div>
        </section>

        {/* WHY PAPERLY SECTION */}
        <section className={styles.whyPaperly}>
          <div className={styles.servicesTitle}>Dlaczego Paperly?</div>
          <div className={styles.servicesHeader}>Zbudowane z myślą o Tobie</div>
          <div className={styles.whyPaperlyList}>
            <div className={styles.whyListItem}>
              <div className={styles.whyListItemIcon}><Wand2 size={28} strokeWidth={2.5}/></div>
              <div className={styles.whyListItemText}>
                <h3 className={styles.whyTitle}>Prostota, której oczekujesz</h3>
                <p className={styles.whyDesc}>Nasz interfejs jest tak prosty, że zaczniesz automatyzować w kilka minut — bez szkoleń, wdrożeń IT i skomplikowanych instrukcji.</p>
              </div>
            </div>
            <div className={styles.whyListItem}>
              <div className={styles.whyListItemIcon}><FileCog size={28} strokeWidth={2.5}/></div>
              <div className={styles.whyListItemText}>
                <h3 className={styles.whyTitle}>Inteligentne dokumenty</h3>
                <p className={styles.whyDesc}>Twórz dynamiczne dokumenty, które same dostosowują treść w zależności od wprowadzonych danych dzięki logice warunkowej.</p>
              </div>
            </div>
            <div className={styles.whyListItem}>
              <div className={styles.whyListItemIcon}><Award size={28} strokeWidth={2.5}/></div>
              <div className={styles.whyListItemText}>
                <h3 className={styles.whyTitle}>Specjalizacja i wsparcie</h3>
                <p className={styles.whyDesc}>Skupiamy się w 100% na automatyzacji dokumentów, aby dostarczyć najlepsze rozwiązanie i ekspertyzę na rynku. Dołącz do grona naszych zadowolonych klientów!</p>
              </div>
            </div>
          </div>
        </section>

        {/* TESTIMONIALS SECTION */}
        <section className={styles.testimonials}>
          <div className={styles.servicesTitle}>Opinie, które mówią same za siebie</div>
          <div className={styles.servicesHeader}>Zaufali nam najlepsi</div>
          <div className={styles.testimonialsGrid}>
            <div className={styles.testimonialCard}>
              <div className={styles.testimonialAvatar} role="img" aria-label="Avatar: Alicja Dudek">AD</div>
              <p className={styles.testimonialQuote}>
                "Paperly to prawdziwy game-changer. Generowanie umów dla nowych pracowników zajmuje mi teraz minuty, a nie godziny. Genialne!"
              </p>
              <div className={styles.testimonialAuthor}>Alicja Dudek</div>
              <div className={styles.testimonialRole}>HR Manager</div>
            </div>
            <div className={styles.testimonialCard}>
              <div className={styles.testimonialAvatar} role="img" aria-label="Avatar: Marek Wiśniewski">MW</div>
              <p className={styles.testimonialQuote}>
                "Automatyzacja pism procesowych z Paperly oszczędziła mi setki godzin. System warunków logicznych jest niesamowicie potężny."
              </p>
              <div className={styles.testimonialAuthor}>Marek Wiśniewski</div>
              <div className={styles.testimonialRole}>Prawnik</div>
            </div>
            <div className={styles.testimonialCard}>
              <div className={styles.testimonialAvatar} role="img" aria-label="Avatar: Jakub Toczyk">JT</div>
              <p className={styles.testimonialQuote}>
                "Jako mała firma musimy liczyć każdą złotówkę. Paperly to najlepsza inwestycja w efektywność, jakiej dokonaliśmy. Z mojej strony gorąco polecam!"
              </p>
              <div className={styles.testimonialAuthor}>Jakub Toczyk</div>
              <div className={styles.testimonialRole}>Właściciel</div>
            </div>
          </div>
        </section>

        {/* FINAL CTA SECTION */}
        <section className={styles.finalCta}>
          <div className={styles.finalCtaContent}>
            <h2 className={styles.finalCtaTitle}>
              Przestań tracić czas na ręczne wypełnianie dokumentów
            </h2>
            <p className={styles.finalCtaDesc}>
              Dołącz do firm, które już automatyzują swoją pracę z Paperly.<br />
              Zacznij oszczędzać 10+ godzin tygodniowo już dziś.
            </p>
            <div className={styles.finalCtaBtns}>
              <HashLink smooth to="/kontakt#formularz" className={styles.finalCtaPrimary}>
                Umów bezpłatną konsultację
              </HashLink>
              <HashLink smooth to="/#services" className={styles.finalCtaSecondary}>
                Dowiedz się więcej
              </HashLink>
            </div>
          </div>
        </section>
      </main>

      {/* FOOTER SECTION */}
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerBrand}>
            <img src="/logo2.png" alt="Paperly Logo" className={styles.footerLogo} />
            <div className={styles.footerBrandText}>
              <span>&copy; {new Date().getFullYear()} Paperly. Wszelkie prawa zastrzeżone.</span>
              <span className={styles.madeInPoland}>Stworzone z ❤️ w Polsce</span>
            </div>
          </div>
          <div className={styles.footerLinks}>
            <HashLink smooth to="/kontakt#formularz" className={styles.footerLink}>Kontakt</HashLink>
            <Link to="/polityka-prywatnosci" className={styles.footerLink}>Polityka Prywatności</Link>
            <Link to="/regulamin" className={styles.footerLink}>Regulamin</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}